import { Link } from 'react-router-dom';
import { ArrowRight, Home } from 'lucide-react';
import { SEO } from '../components/seo';

export function NotFound() {
  return (
    <>
      <SEO
        title="Pagina niet gevonden"
        description="Deze pagina bestaat niet (meer). Ga terug naar de homepage of bekijk onze kennisbank over de externe vertrouwenspersoon."
        canonicalUrl="/404"
        noIndex
      />
      <div className="pt-28">
        <section className="bg-[#0284c7] text-white">
          <div className="container py-24 md:py-32 max-w-3xl text-center">
            <p className="text-xs font-semibold text-white/60 uppercase tracking-[0.2em] mb-6">Foutmelding 404</p>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Deze pagina bestaat niet (meer).</h1>
            <p className="text-xl text-white/85 mb-10">
              Mogelijk is de link verouderd of klopt het webadres niet. Onderstaande pagina's helpen je verder.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/" className="btn-primary">
                <Home className="w-4 h-4" /> Naar de homepage
              </Link>
              <Link to="/kennisbank" className="btn-secondary">
                Naar de kennisbank <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
